import gameIframe from '@ps/bridge/iframe/iframe'
import qc from 'qc'

export const add = ({ uniqueName }: { uniqueName: string }): qc.Node => {
  const node = gameIframe.qcGame.add.node(gameIframe.gamePlay)
  node.uniqueName = uniqueName
  node.name = 'IVScene_' + node.uuid.slice(0, 8)
  node._maxAnchor.x = node._maxAnchor.y = 1
  node._minAnchor.x = node._minAnchor.y = 0
  node.pivotX = 0
  node.pivotY = 0
  node.left = 0
  node.right = 0
  node.top = 0
  node.bottom = 0
  return node
}
